import React, { FunctionComponent } from 'react';

// MUI
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';

// Properties
import * as styles from './Tile.styles';

type TProps = {
    title?: string;
}

const Tile: FunctionComponent<TProps> = ({
    title,
    children,
}) => {
    return (
        <Paper sx={styles.tile} square>
            <Grid container>
                <Grid item xs={12} lg={3}>
                    <Box sx={styles.title}>
                        { title }
                    </Box>
                </Grid>
                <Grid item xs={12} lg={9}>
                    { children }
                </Grid>
            </Grid>
        </Paper>
    );
};

export default Tile;
